import React, { useState } from 'react';
import './styles/asyncButton.css';

type AsyncButtonProps = {
    onClick: () => Promise<void>;
    children: React.ReactNode;
    componentButton?: React.ElementType;
    styles?: React.CSSProperties;
};

export function AsyncButton({ onClick, children, componentButton: ComponentButton = 'button', styles }: AsyncButtonProps) {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        if (loading) return;

        try {
            setLoading(true);
            await onClick();
        } finally {
            setLoading(false);
        }
    };

    return (
        <ComponentButton onClick={handleClick} disabled={loading} style={{ ...styles }}>
            {loading ? (
                <span style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <div className="loaderButtonAsync"></div>
                </span>
            ) : (
                children
            )}
        </ComponentButton>
    );
}
